import { fromJS } from 'immutable';
import * as ACTIONS from '../containers/constants';

const initialState = fromJS({});

export function cryodexReducer(state = initialState, action) {

  switch (action.type) {
    case ACTIONS.CRYODEX_CRYODEX_UPDATE:
      return {
        ...state,
        data: action.payload,
      };
    case ACTIONS.CRYODEX_UPDATE_ISOLATED_CRYODEX:
      return {
        ...state,
        isolated: action.payload,
      };
    case ACTIONS.CRYODEX_INVITE_UPDATE:
      return {
        ...state,
        isolated: {
          ...state.isolated,
          invite: action.payload.message
        }
      };
    case ACTIONS.CRYODEX_EDIT_UPDATE:

      return {
        ...state,
        editing: action.payload,
        saving: false
      }
    case ACTIONS.SAVING_COMPLETE:
      return {
        ...state,
        saving: true,
      }
    case ACTIONS.SAVING_CLOSED:
      return {
        ...state,
        saving: false,
      }
    default:
      return state;
  }
}

export default cryodexReducer;
